import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Simpleforms } from './simpleforms.model';
import { environment } from '../../environments/environment';

@Injectable()
export class Simpleformservice {

  constructor(private httpClient: HttpClient) {}

  public save(data: any): Observable<any> {
    return this.httpClient.post(environment.api + '/simpleform', data);
  }

  public dealerAutocomplete(query: any): Observable<any> {
    const params = new HttpParams({fromObject: query});
    params['front'] = true;
    return this.httpClient.get<any>(environment.api + '/distributors/autocomplete', { params: params });
  }

  public modelAutocomplete(query: any): Observable<any> {
    query['front'] = true;
    return this.httpClient.post<any>(environment.api + '/products', query);
  }

}

